<template>
  <div v-if="state.splits.value" class="pace-splits">
    <button type="button" class="pace-splits__open" @click="isShowingSplits = true">
      <span class="material-icons" aria-hidden="true">bar_chart</span>
      {{ $t('recordings.activity.view_splits') }}
      <span class="material-icons" aria-hidden="true">chevron_right</span>
    </button>

    <SplitTimesModal v-if="isShowingSplits" :state="state" :activity="activity" :pref="pref" @close="isShowingSplits = false" />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import type { MeasurementPrefUtility } from '../../../utils/helpers/MeasurementPref';
import type { PaceSplitTrack } from '../../../utils/recordingActivity/paceSplits';
import type { RecordingActivity } from '../../../utils/recordingActivity/recordingActivity';
import { usePaceSplits } from '../usePaceSplits';
import SplitTimesModal from './SplitTimesModal.vue';

const props = defineProps<{ activity: RecordingActivity & { splitTrack: PaceSplitTrack }; pref: MeasurementPrefUtility }>();

const state = usePaceSplits(props.activity.splitTrack, props.activity.heartRate?.samples ?? null, props.pref.metresFromBigUnit(1));
const isShowingSplits = ref(false);
</script>

<style scoped>
.pace-splits {
  display: flex;
  justify-content: flex-end;
  margin-top: 1.25rem;
}

.pace-splits__open {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.6rem 0.9rem 0.6rem 1rem;
  font-weight: 700;
  color: #fff;
  background: var(--gray-raised, #2a2c34);
  border: 0;
  border-radius: 999px;
  transition: background-color 0.15s;
}

.pace-splits__open:hover,
.pace-splits__open:focus-visible {
  background: var(--gray-hover, #30323b);
}

.pace-splits__open .material-icons {
  font-size: 20px;
}

.pace-splits__open .material-icons:first-child {
  color: #2cc2e3;
}
</style>
